import type { FaireProductEntity } from "../../entity_types/product";

export const p_tywhnyw7hf: FaireProductEntity = {
  token: "p_tywhnyw7hf",
  type: "product",
  name: "Three Cats Candle Holder",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/3c9df2d6a83ad06ec3e4b4734e3fcd699ea5fc117c7642b3cf16b3db895fb23f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2ee9d8c5b26ccdaeb2b3e5e39df1a0d6bb6ae13b9ab17aa246bcae36969b0b0d.jpeg",
    "https://cdn.faire.com/fastly/53e10b1b33a439cb6ebdbfc2da4f7d4024002b16f03f3c2d6b017ce5ff45fdbe.jpeg",
    "https://cdn.faire.com/fastly/e9e19911f49805e4b6dd04849463ae2e46af6fe18de4d9a75fd1e1316ae82337.jpeg"
  ],
  priceDollars: 12.5,
  description: "A decorative candle holder that coordinates well with décor from our Halloween Collection. Seasonal candle holder features a sculpted base with painted details displaying three black cats around a cauldron with space inside to place a single candle. Our Three Cats candle holder fits standard tealight candles and can free-stand on flat surface for display. Candle pictured not included. A vintage Halloween home accent perfect for adding natural lighting to any space.",
  tags: [],
  msrpDollars: 24.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:27.435Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
